@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading && !isUiTest) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="pfs.updateOrderPayload.isModified"
      [isValid]="true"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      [saveLabel] = "actionType === 'Replace'  ? 'Replace & Submit' : 'Save'"
      (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="slideOutTitle" [tooltipRequiresTruncation]="true">{{slideOutTitle}}</span>
    </irb-editor-sidebar-banner>
    <div class="body" [style.height]="bodyHeight" #body>
      @if (!multiSymbol) {
        <irb-order-header [currentOrderData]="currentOrderData" [bidAndAskPrices]="bidAndAskPrices" [swapBidAndAskPrices]="swapBidAndAskPrices"
        [actionType]="actionType" ></irb-order-header>
      }
      <mat-accordion #accordian="matAccordion" [multi]="true">
        <mat-expansion-panel id="TRADE_DETAILS" [expanded]="ies.getDefaultExpansionState('TRADE_DETAILS')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADE_DETAILS','opened') : ies.updateExpansionState('TRADE_DETAILS','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADE_DETAILS','closed') : ies.updateExpansionState('TRADE_DETAILS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Orders
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent  >
            <!-- <irb-com-accounts #assignedAccounts *ngIf="data" [(data)]="data" (change)="onInputChange()"></irb-com-accounts> -->
            @if (!isUiTest) {
              <irb-trade-details [tradeDetails]="selectedOrdersArr"></irb-trade-details>
            }
          </ng-template>
        </mat-expansion-panel>
        @if (bidAndAskPricesReceived) {
          <mat-expansion-panel  id="TRADE_INSTRUCTIONS" [expanded]="ies.getDefaultExpansionState('TRADE_INSTRUCTIONS')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADE_INSTRUCTIONS','opened') : ies.updateExpansionState('TRADE_INSTRUCTIONS','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADE_INSTRUCTIONS','closed') : ies.updateExpansionState('TRADE_INSTRUCTIONS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Order Instructions
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent >
              @if (currentOrderData && !isUiTest) {
                <irb-trade-instructions [data]="currentOrderData" [parentObj] = "inventoryComponentRef" [actionType]="actionType" [bidAndAskPrices]="bidAndAskPrices"></irb-trade-instructions>
              }
            </ng-template>
          </mat-expansion-panel>
        }
        @if (isAllMutualFund) {
          <mat-expansion-panel id="REINVESTMENT" [expanded]="ies.getDefaultExpansionState('REINVESTMENT')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('REINVESTMENT','opened') : ies.updateExpansionState('REINVESTMENT','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('REINVESTMENT','closed') : ies.updateExpansionState('REINVESTMENT','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Reinvestment and Fees
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent  >
              @if (!isUiTest) {
                <irb-reinvestment-trade [parentObj] = "inventoryComponentRef" [data]="currentOrderData" [actionType]="actionType"></irb-reinvestment-trade>
              }
            </ng-template>
          </mat-expansion-panel>
        }
        @if (actionType!=='MultiEdit') {
          <mat-expansion-panel id="ORDER_HISTORY" [expanded]="ies.getDefaultExpansionState('ORDER_HISTORY')"
            (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ORDER_HISTORY','opened') : ies.updateExpansionState('ORDER_HISTORY','opened')"
            (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ORDER_HISTORY','closed') : ies.updateExpansionState('ORDER_HISTORY','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Order History
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent  >
              @if (currentOrderData && !isUiTest) {
                <irb-order-histroy [(data)]="currentOrderData" [(inventoryObj)] = "inventoryComponentRef" [editTradingInstructionObj]="editTradingInstructionsRef"></irb-order-histroy>
              }
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}
